
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Platform, SraEventAction } from '@/@types/graphql-types';
import {
	TrackSraEventDocument,
	TrackSraEventMutation,
	TrackSraEventMutationVariables,
} from '@/graphql/mutation/TrackSraEvent.mutation';
import { TrackingAppId } from '@/helpers/tracking/tracking-helper';
import { UrlMetadataResponse } from '@/interfaces/responses/url-metadata';
import type { SponsoredAdFragmentFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import { SponsoredAdSportFragmentFragment } from '@/pages/graphql/fragments/SponsoredAdSport.fragment';

const Language = namespace('language');
const Routing = namespace('routing');

export enum EVENT_TYPES {
	SR_EVENT = 'trackSraEvent',
}

/**
 * Mixin to inject Backend driven Tracking functions
 * - trackSraEvent
 */
@Component
export default class BackendTrackingMixin extends Vue {
	@Language.Getter declare country: string;
	@Language.Getter declare language: string;

	@Routing.Getter currentPageType: string;
	@Routing.Getter declare urlMetadata: UrlMetadataResponse | null;

	get $backendTracking() {
		const { $apollo, country, currentPageType, language } = this;
		const appId = TrackingAppId;

		return {
			trackSraEvent(
				action: SraEventAction,
				sponsoreAd: SponsoredAdFragmentFragment | SponsoredAdSportFragmentFragment,
				jwEntityID?: string,
				position?: number,
				progress?: number
			) {
				if (currentPageType === null) console.error('Empty Page Type, action: ', action);

				const { bidId } = sponsoreAd;
				$apollo
					.mutate<TrackSraEventMutation, TrackSraEventMutationVariables>({
						mutation: TrackSraEventDocument,
						variables: {
							input: {
								bidId,
								action,
								sraInput: {
									country,
									platform: Platform.Web,
									pageType: currentPageType,
									language,
									appId,
								},
								jwEntityID,
								position,
								progress,
							},
						},
					})
					.then(() => {})
					.catch(() => {});
			},
		};
	}
}
